module.exports = __webpack_public_path__ + "static/media/background_login.b3202144.jpg";